module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rank"
  }, [_c('div', {
    staticClass: "classify-topBar"
  }, [_c('div', {
    staticClass: "classify-topNav"
  }, [_c('div', {
    staticClass: "classify-topNav-left"
  }, [_c('div', {
    staticClass: "classify-backBox",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back",
      "color": "#fff",
      "size": "32"
    }
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "classify-topNav-right"
  }, [_c('div', {
    staticClass: "classify-homeBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/home"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "home",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "classify-personalBox"
  }, [_c('router-link', {
    attrs: {
      "exact": "",
      "to": "/login"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-person",
      "color": "#fff",
      "size": "32"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "rank-container"
  }, [_c('ul', _vm._l((_vm.rankSort), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "exact": "",
        "to": '/bookdetails/' + item.title + '&' + item.id,
        "tag": "a"
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v("人气:" + _vm._s(item.reading))])], 1)
  }))]), _vm._v(" "), _c('classify-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classify-titleBox"
  }, [_c('span', {
    staticClass: "classify-title"
  }, [_vm._v("排行页面")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-17128fd4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/rank/index.vue
// module id = 180
// module chunks = 1